import { css } from '@emotion/core';
import { logError } from '@core/logging';
import { getBrowser, getOS } from '@core/userAgent';
export function shouldApplyFocusVisiblePolyfill() {
    return getBrowser() === 'Safari' || getOS() === 'iOS';
}
/**
 * @returns CSS styles that hides focus outline when not triggering the focus
 * with keyboard.
 */
export function createFocusOutlineFixStyle() {
    return shouldApplyFocusVisiblePolyfill()
        ? // CS-127: Support browser without native focus-visible and Safari.
            css `
        button:focus:not(.focus-visible) {
          outline: none;
        }
      `
        : // Support browser with native focus-visible.
            css `
        button:focus:not(:focus-visible) {
          outline: none;
        }
      `;
}
/**
 * Applies focus-visible polyfill on Safari.
 * CS-127: Use focus-visible polyfill to ensure the focus ring only shows up
 * when interacting with the keyboard.
 */
export function applyFocusVisible(shadowRoot) {
    if (!shouldApplyFocusVisiblePolyfill()) {
        return;
    }
    import('focus-visible').then(() => {
        if (window.applyFocusVisiblePolyfill) {
            window.applyFocusVisiblePolyfill(shadowRoot);
        }
        else {
            logError(new Error('focus visible polyfill is not properly loaded'));
        }
    });
}
